import React from 'react'
import Menu from '../../components/Menu'
import Banner from '../../components/Banner'

const Home = () => {
    return(
        <>
            <Menu />
            <Banner />
        </>

    )
}

export default Home